import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export default function PublicRoute({ children }) {
    const { user } = useSelector((state) => state.auth);

    const isLoggedIn = useAuth();

    return !isLoggedIn ? children : <Navigate to={user.role === "admin" ? "/admin/dashboard" : "/student/course"} />;
}
